"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateFinalConfig = exports.PalletConfigObj = exports.newPalletConfiguration = exports.getDefaultPallets = exports.getLayoutHeight = void 0;
const geometry_1 = require("./geometry");
const layouts_1 = require("./layouts");
const sort_1 = require("./sort");
function getLayoutHeight(pLayout, pBoxes) {
    if (pLayout.boxPositions.length === 0)
        return 0;
    let lBox = pBoxes[pLayout.boxPositions[0].index];
    return lBox.dimensions.height;
}
exports.getLayoutHeight = getLayoutHeight;
/*
 * {Name: "Standard GMA Pallet"; Dimensions: "1016 x 1219mm"} and {Name: "EUR-pallet"; Dimensions: "800 x 1200mm"}
 */
function getDefaultPallets() {
    return [
        {
            name: '40 x 48 in.',
            id: 'eca7450b-bb55-4b98-82a0-bdf72e6609e9',
            Dimensions: { width: 1016, length: 1219, height: 165 },
            point: { x: 0, y: 0, z: 0, θ: 0 },
            Stack: [],
            Layouts: [],
            Detection: {
                TopEnabled: false,
                Top: 0,
                BottomEnabled: false,
                Bottom: 0,
            },
        },
        {
            name: 'EUR',
            id: '0450d23e-0804-4500-ac3f-0acdec598f74',
            Dimensions: { width: 800, length: 1200, height: 144 },
            point: { x: 0, y: 0, z: 0, θ: 0 },
            Stack: [],
            Layouts: [],
            Detection: {
                TopEnabled: false,
                Top: 0,
                BottomEnabled: false,
                Bottom: 0,
            },
        },
    ];
}
exports.getDefaultPallets = getDefaultPallets;
function newPalletConfiguration(name) {
    return {
        name,
        boxes: [],
        slipsheets: [],
        pallets: getDefaultPallets(),
    };
}
exports.newPalletConfiguration = newPalletConfiguration;
class PalletConfigObj {
    constructor() {
        this.complete = true;
        this.boxCoordinates = [];
        this.config = {
            name: 'null configuration',
            boxes: [],
            slipsheets: [],
            pallets: [],
        };
    }
    // use to absorb data into class.
    static from(spc) {
        const c = new PalletConfigObj();
        Object.assign(c, spc);
        // validate + fix configurations
        c.config.pallets.forEach(function (p) {
            if (!p.Layouts || p.Layouts === null)
                p.Layouts = [];
            if (!p.Stack || p.Stack === null)
                p.Stack = [];
        });
        return c;
    }
    hasBox() {
        return this.config.boxes.length > 0;
    }
    hasSlipSheet() {
        return this.config.slipsheets.length > 0;
    }
    hasPallet() {
        return this.config.pallets.length > 0;
    }
    hasLayout() {
        return (this.config.pallets.map(p => p.Layouts.length).filter(x => x > 0).length >
            0);
    }
    hasStack() {
        return (this.config.pallets.map(p => p.Stack.length).filter(x => x > 0).length > 0);
    }
    getBox(box_index) {
        return this.config.boxes[box_index];
    }
    getPallet(pallet_index) {
        return this.config.pallets[pallet_index];
    }
    getStack(pallet_index, stack_index) {
        return this.getPallet(pallet_index).Stack[stack_index];
    }
    getLayer(pallet_index, stack_index, layer_index) {
        return this.getStack(pallet_index, stack_index).layers[layer_index];
    }
    findPalletIDAndStackIDFromSKUID(skuID) {
        var _a;
        const ps = this.config.pallets;
        for (let p = 0; p < ps.length; p++) {
            const pallet = ps[p];
            for (let s = 0; s < pallet.Stack.length; s++) {
                const stack = pallet.Stack[s];
                const layers = stack.layers;
                if (layers.length > 0) {
                    const layout_index = layers[0].index;
                    if (pallet.Layouts.length > layout_index) {
                        const layout = pallet.Layouts[layout_index];
                        const boxPos = layout.boxPositions;
                        const boxIndex = boxPos[0].index;
                        const box = this.getBox(boxIndex);
                        const lMatches = ((_a = box.skuId) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (skuID === null || skuID === void 0 ? void 0 : skuID.toLowerCase());
                        if (lMatches)
                            return { PalletID: p, StackID: s };
                    }
                }
            }
        }
        return void 0;
    }
    getLayout(pallet_index, layout_index) {
        return this.getPallet(pallet_index).Layouts[layout_index];
    }
    getLayoutHeight(pPalletIndex, pLayoutIndex) {
        return getLayoutHeight(this.getLayout(pPalletIndex, pLayoutIndex), this.config.boxes);
    }
    getStackHeight(pPalletIndex, pStackIndex) {
        let lHeight = 0;
        const lStack = this.getPallet(pPalletIndex).Stack[pStackIndex];
        lStack.layers.forEach(lLayer => {
            lHeight += this.getLayoutHeight(pPalletIndex, lLayer.index);
        });
        return lHeight;
    }
    getStackLayout(pPalletIndex, pStackIndex, pLayerIndex) {
        const lPallet = this.getPallet(pPalletIndex), lStack = this.getStack(pPalletIndex, pStackIndex);
        const lStackLayout = lStack.layers[pLayerIndex];
        return layouts_1.LayoutTransform.Transform(lStackLayout.transform, lPallet, this.config.boxes, lStackLayout.index);
    }
    getSortedStackLayout(pPalletIndex, pStackIndex, pLayerIndex, pSide) {
        let lTargetLayout = this.getStackLayout(pPalletIndex, pStackIndex, pLayerIndex);
        const lConfigCp = JSON.parse(JSON.stringify(this));
        lConfigCp.config.pallets = [lConfigCp.config.pallets[pPalletIndex]];
        const lPalletCp = lConfigCp.config.pallets[0];
        lPalletCp.Layouts = [lTargetLayout];
        lPalletCp.Stack = [0];
        // Transform to robot space
        lTargetLayout = layouts_1.LayoutTransform.Transform(layouts_1.LayoutTransform.TransformType.ReflectGlobalY, lPalletCp, lConfigCp.config.boxes, 0);
        lPalletCp.Layouts = [lTargetLayout];
        lTargetLayout = layouts_1.LayoutTransform.Transform(layouts_1.LayoutTransform.TransformType.ReflectGlobalX, lPalletCp, lConfigCp.config.boxes, 0);
        lPalletCp.Layouts = [lTargetLayout];
        let lSuccess = (0, sort_1.marcSort)(lConfigCp, pSide); /* sort rifled configuration */
        if (!lSuccess) {
            return this.getStackLayout(pPalletIndex, pStackIndex, pLayerIndex);
        }
        else {
            lPalletCp.sorted = true;
            return lTargetLayout;
        }
    }
    getBoxCountOffset(pPalletIndex, pStackIndex, pStartLayer, pStartBox) {
        const lStack = this.getStack(pPalletIndex, pStackIndex);
        let lBoxCount = 0;
        for (let lLayerIndex = 0; lLayerIndex < lStack.layers.length; lLayerIndex++) {
            const lLayer = lStack.layers[lLayerIndex], lLayout = this.getLayout(pPalletIndex, lLayer.index), lIsLastLayer = lLayerIndex === pStartLayer;
            for (let lBoxIndex = 0; lBoxIndex < lLayout.boxPositions.length; lBoxIndex++) {
                if (lIsLastLayer && lBoxIndex === pStartBox)
                    break;
                lBoxCount++;
            }
            if (lIsLastLayer)
                break;
        }
        return lBoxCount;
    }
    getPickCountLayout(pallet_index, layout_index) {
        return this.getLayout(pallet_index, layout_index).boxPositions.length;
    }
    getBoxCountLayout(pallet_index, layout_index) {
        const bPos = this.getLayout(pallet_index, layout_index).boxPositions;
        let count = 0;
        for (let b = 0; b < bPos.length; b++) {
            count += (bPos[b].multipick || 0) + 1;
        }
        return count;
    }
    getLayoutCountStack(pallet_index, stack_index) {
        return this.getStack(pallet_index, stack_index).layers.length;
    }
    /* returns [layerIndex, boxIndexInLayer] */
    getLayoutAndRelativeIndexForBox(pPalletIndex, pStackIndex, pBoxIndex) {
        const lStack = this.getStack(pPalletIndex, pStackIndex);
        let lTotalBoxes = 0;
        for (let lLayerIndex = 0; lLayerIndex < lStack.layers.length; lLayerIndex++) {
            const lBoxesInLayer = this.getBoxCountLayout(pPalletIndex, lStack.layers[lLayerIndex].index);
            lTotalBoxes += lBoxesInLayer;
            if (lTotalBoxes > pBoxIndex)
                return [lLayerIndex, lBoxesInLayer - (lTotalBoxes - pBoxIndex)];
        }
        return [0, 0];
    }
    getAbsoluteCount(pPalletIndex, pStackIndex, pLayerIndex, pRelativeBoxIndex) {
        let lCount = 0;
        const _lMy = this;
        _lMy
            .getStack(pPalletIndex, pStackIndex)
            .layers.forEach(function (pLayer, pIndex) {
            if (pIndex > pLayerIndex)
                return;
            if (pIndex === pLayerIndex)
                lCount += pRelativeBoxIndex;
            else
                lCount += _lMy.getBoxCountLayout(pPalletIndex, pLayer.index);
        });
        return lCount;
    }
    getPickCountStack(pallet_index, stack_index) {
        let count = 0;
        const my = this;
        my.getStack(pallet_index, stack_index).layers.forEach((pLayer_t) => {
            count += my.getPickCountLayout(pallet_index, pLayer_t.index);
        });
        return count;
    }
    getBoxCountStack(pallet_index, stack_index) {
        let count = 0;
        const my = this;
        my.getStack(pallet_index, stack_index).layers.forEach((pLayer_t) => {
            count += my.getBoxCountLayout(pallet_index, pLayer_t.index);
        });
        return count;
    }
    getSSCountStack(pallet_index, stack_index) {
        let count = 0;
        const my = this;
        const s = my.getStack(pallet_index, stack_index);
        if (!s.slipSheet)
            return 0;
        const layers = s.layers;
        for (let l = 0; l <= layers.length; l++) {
            count += (0, geometry_1.hasSlipSheet)(l, layers.length, s.slipSheet) ? 1 : 0;
        }
        return count;
    }
}
exports.PalletConfigObj = PalletConfigObj;
function GenerateFinalConfig(startingConfig, gripper) {
    const config = { ...startingConfig };
    const { pallets } = config;
    let boxCoordinates = [];
    let g_x_shift = (gripper.x_high - gripper.x_low) / 2;
    let g_y_shift = (gripper.y_high - gripper.y_low) / 2;
    const stackShifts = new Array(config.boxes.length).fill(0);
    pallets.forEach((p, palletIndex) => {
        const { Layouts, Stack } = p;
        const [corner1, corner2, corner3] = (0, geometry_1.getPalletCorners)(p, gripper);
        const palletHeight = (corner1.z + corner2.z + corner3.z) / 3;
        const Ydirection = (0, geometry_1.Subtract3D)(corner1, corner2);
        const Xdirection = (0, geometry_1.Subtract3D)(corner3, corner2);
        const φ_pallet = (0, geometry_1.getXAxisAngle)(Xdirection);
        let currentHeightIncrement = palletHeight;
        Stack[0].layers.forEach((pLayer_t, stackIndex) => {
            const n = pLayer_t.index;
            const { boxPositions } = Layouts[n];
            let lLayerHeight = 0;
            boxPositions.forEach((b, i) => {
                let { position, rotated } = b;
                const box = config.boxes[b.index];
                lLayerHeight = box.dimensions.height;
                const pickLocation = (0, geometry_1.to_coord)(box.pickLocation);
                const { x, y } = position;
                let boxWidth = box.dimensions.width;
                let boxLength = box.dimensions.length;
                let temp = boxWidth;
                boxWidth = rotated ? boxLength : boxWidth;
                boxLength = rotated ? temp : boxLength;
                const θ_drop = (rotated ? 90 : 0) + φ_pallet;
                const θ_drop_rad = (θ_drop * Math.PI) / 180;
                let boxXmid = boxWidth / 2;
                let boxYmid = boxLength / 2;
                let x_shift = g_y_shift * Math.sin(θ_drop_rad) - g_x_shift * Math.cos(θ_drop_rad);
                let y_shift = -g_x_shift * Math.sin(θ_drop_rad) - g_y_shift * Math.cos(θ_drop_rad);
                let x_pos = (0, geometry_1.MultiplyScalar)(Xdirection, x);
                let y_pos = (0, geometry_1.MultiplyScalar)(Ydirection, 1 - y);
                let Xunit = (0, geometry_1.MultiplyScalar)(Xdirection, 1 / (0, geometry_1.Norm)(Xdirection));
                let Yunit = (0, geometry_1.MultiplyScalar)(Ydirection, 1 / (0, geometry_1.Norm)(Ydirection));
                x_pos = (0, geometry_1.Add3D)(x_pos, (0, geometry_1.MultiplyScalar)(Xunit, boxXmid));
                y_pos = (0, geometry_1.Add3D)(y_pos, (0, geometry_1.MultiplyScalar)(Yunit, -boxYmid));
                let averagePosition = (0, geometry_1.Add3D)(x_pos, y_pos);
                averagePosition = (0, geometry_1.Add3D)(averagePosition, corner2);
                let z_add = currentHeightIncrement;
                if (stackIndex > 0) {
                    z_add -= box.dimensions.height;
                }
                averagePosition.z = z_add;
                let dropLocation = { ...averagePosition, θ: θ_drop };
                dropLocation.x += x_shift;
                dropLocation.y += y_shift;
                let linearPathDistance = (0, geometry_1.Norm)((0, geometry_1.Subtract3D)(pickLocation, dropLocation));
                if (box.pickFromStack) {
                    pickLocation.z += box.dimensions.height * stackShifts[b.index];
                    stackShifts[b.index]++;
                }
                boxCoordinates.push({
                    pickLocation: { ...pickLocation },
                    dropLocation,
                    dimensions: box.dimensions,
                    boxIndex: b.index,
                    palletIndex,
                    stackIndex,
                    linearPathDistance,
                    boxDetection: box.boxDetection,
                    detectionEnabled: box.detectionEnabled,
                });
            });
            if (stackIndex > 0)
                currentHeightIncrement -= lLayerHeight;
        });
    });
    return {
        config: startingConfig,
        boxCoordinates,
        complete: true,
    };
}
exports.GenerateFinalConfig = GenerateFinalConfig;
